import ApiService from "../../ApiService";

const CommonService = {
    getTaskProgress: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/common/gettaskprogress", { id }, successCallback, failureCallback);
    },
};

export default CommonService;
